import { render, staticRenderFns } from "./DetailsPurcharseOrder.vue?vue&type=template&id=67e11e75&lang=pug&"
import script from "./DetailsPurcharseOrder.vue?vue&type=script&lang=js&"
export * from "./DetailsPurcharseOrder.vue?vue&type=script&lang=js&"
import style0 from "./DetailsPurcharseOrder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports